module.exports = __webpack_public_path__ + "img/starzplay.0840d567.jpg";